export const CircleCheckIcon = () => <i className="fa-regular fa-circle-check" />
